import React from 'react'
import "./HeroImageStyle.css"
import introimg from "../assets/intr-bg.jpg"
import { Link } from 'react-router-dom'

const HeroImage = () => {
  return (
    <div className='hero'>
      <div className="mask">
        <img className='intro-img'
          src={introimg}
          alt='introimage' />
      </div>
      <div className='content'>
        <p>HI, I AM SHAMIL</p>
        <h1>Front End Developer</h1>
        <div>
          <Link to="/Project" className='btn'>Projects</Link>
          <Link to="https://drive.google.com/file/d/1Vt5znH80AkQHIL4PA3hlnSSz0N6ri9v3/view?usp=drive_link" className='btn'>Resume</Link>

        </div>
      </div>

    </div>
  )
}

export default HeroImage